import * as React from 'react';
import * as styles from './DragBar.sass';

export default class Toolbar extends React.Component {
	render () {
		return (
			<header className={styles.DragBar} />
		);
	}
}
